import React, { Component } from "react";
import "../../css/pages/customers.css";
import "../../css/pages/dropdown.css";
import { Link } from "react-router-dom";
import moment from "moment";
import Nav from "react-bootstrap/esm/Nav";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import * as FileSaver from "file-saver";
import SideNav from "../components/SideNav";
import TopNav from "../components/TopNav";
import {
  fetchLoan,
  fetchLoanSchedules,
  fetchBorrowerDetails,
} from "../actions/p2p";

import AcceptLoan from "../components/modals/AcceptLoan";
import EditLoan from "../components/modals/EditLoan";
import CancelLoan from "../components/modals/CancelLoan";
import LoanScheduleTransactions from "../components/modals/LoanScheduleTransactions";

import { fillUser } from "../actions/account";
import AssignLoan from "../components/modals/AssignLoan";

class ViewLoan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      schedules: [],
      edit: false,
      assign: [],
      cancel: false,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    this.fetchLoanDetails(match.params.id);
  }

  async fetchBorrower(id) {
    return new Promise((resolve, reject) => {
      fetchBorrowerDetails(id)
        .then(({ data }) => {
          this.setState({
            borrower_details: data,
            borrower_approved_loans: data.borrower.loans
              .filter((loan) =>
                ["approved", "settled"].includes(
                  loan?.status?.status?.toLowerCase()
                )
              )
              .sort(
                (left, right) =>
                  new Date(right.created_on).getTime() -
                  new Date(left.created_on).getTime()
              ),
          });
          resolve(true);
        })
        .catch((error) => {
          toast.error(
            error.response?.data?.message ||
            error.response?.statusText ||
            error.message ||
            "Seems like something went wrong with your request. Please try again."
          );
          reject(error);
        });
    });
  }

  formatAmount = (num) => {
    if (+num) {
      return parseFloat(num)
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    return "0";
  };

  fetchLoanDetails = async (id) => {
    try {
      // eslint-disable-next-line max-len
      const {
        data: { schedule_pdf, schedule_excel },
      } = await fetchLoanSchedules(id).catch(async (err) => err);
      this.setState({
        schedule_pdf,
        schedule_excel,
      });
      const {
        data: { loan },
      } = await fetchLoan(id).catch(async (err) => err);
      const details = [];
      const loan_history = [];
      const personal_details = [];
      const education_details = [];
      const guarantor = [];
      details.push(
        {
          title: "Principal",
          description: `₦${Number(loan?.loan_amount).toLocaleString()}`,
        },
        {
          title: "Interest",
          description: `₦ ${Number(loan?.interest_due).toLocaleString()}`,
        },
        {
          title: "Interest Rate",
          description: `${Number(loan?.interest_rate).toLocaleString()}%`,
        },
        {
          title: "Transaction Fee",
          description: `₦ ${Number(
            loan?.transaction_fees.toFixed(2)
          ).toLocaleString()}`,
        },
        {
          title: "Platform Deductions",
          description: `₦ ${Number(
            loan?.platform_fees.toFixed(2)
          ).toLocaleString()}`,
        },
        {
          title: "Your Earnings",
          description: `₦ ${Number(
            +loan?.interest_due -
            (+loan?.platform_fees + +loan?.transaction_fees)
          )
            .toFixed(2)
            .toLocaleString()}`,
        },
        {
          title: "Amount Due",
          description: `₦
            ${Number(
            loan?.schedules?.reduce(
              (acc, schedule) => acc + schedule.amount_due,
              0
            )
          )
              .toFixed(2)
              .toLocaleString()}`,
        },
        {
          title: "Tenor",
          description: `${Number(loan?.tenor).toLocaleString()}
            ${" "}
            ${loan?.tenor_period}`,
        },
        {
          title: "Status",
          description: `${loan?.status?.status}`,
        },
        {
          title: "Application Date",
          description: `${moment(loan?.created_on).format(
            "MMM DD, YYYY, h:mm:ss a"
          )}`,
        },
        {
          title: "Date Disbursed",
          description: `${loan?.disbursed_on
            ? moment(loan?.disbursed_on).format("MMM DD, YYYY, h:mm:ss a")
            : "-"
            }`,
        },
        {
          title: "Purpose of Loan",
          description: `${loan?.loan_profile?.purpose || "-"}`,
        }
      );
      let borrower = false;
      borrower = await this.fetchBorrower(loan?.user_id);
      if (!borrower) return;

      const { borrower_details, borrower_approved_loans } = this.state;

      const borrower_approved_loans_value = borrower_approved_loans?.reduce(
        (acc, $loan) => acc + $loan.loan_amount,
        0
      );

      loan_history.push(
        {
          title: "Paid Loans",
          description: `${borrower_details?.total_paid || "None"}`,
        },
        {
          title: "Bad Loans",
          description: `${borrower_details.total_over_due || "None"}`,
        },
        {
          title: "Loans Approved",
          description: `${borrower_approved_loans?.length}`,
        },
        {
          title: "Value of Loans Approved",
          description: `₦${this.formatAmount(borrower_approved_loans_value)}`,
        },
        {
          title: "Total Loan Requests",
          description: `${borrower_details.total_loan}`,
        },
        {
          title: "Date of Last Loan Approved",
          description: borrower_approved_loans?.[0]?.created_on
            ? `${moment(borrower_approved_loans?.[0]?.created_on).format(
              "MMM DD, YYYY, h:mm:ss a"
            )}`
            : "-",
        },
        {
          title: "Borrower Since",
          description: `${moment(borrower_details.borrower_since).format(
            "MMM DD, YYYY, h:mm:ss a"
          )}`,
        }
      );
      const filter_id = loan?.user?.documents.filter(
        (obj) => obj.status === "Approved"
      );
      let valid_id = "-";
      if (filter_id.length > 0) valid_id = filter_id[0]?.url;

      personal_details.push(
        {
          title: "Borrower ID",
          description: `${loan?.user_id || "-"}`,
        },
        {
          title: "Name",
          description: `${`${loan?.user?.first_name} ${loan?.user?.last_name}` || "-"
            }`,
        },
        {
          title: "Email",
          description: `${loan?.user?.email || "-"}`,
        },
        {
          title: "Phone Number",
          description: `${loan?.user?.phone_number || "-"}`,
        },
        {
          title: "Age",
          description: `${moment(new Date()).diff(moment(loan?.user?.dob), "years") || "-"
            }`,
        },
        {
          title: "City",
          description: `${loan?.user?.city}`,
        },
        {
          title: "State",
          description: `${loan?.user?.state}`,
        },
        {
          title: "Tier",
          description: `${loan?.user?.tier?.name}`,
        },
        {
          title: "Status",
          description: `${loan?.user?.status}`,
        },
        {
          title: "Address Verification Status",
          description: `${loan?.loan_profile?.address || "-"}`,
        },
        {
          title: "Valid ID",
          description: `${valid_id === "-"
            ? "-"
            : `<a href="${valid_id}" target="_blank" rel="noopener noreferrer">View</a>`
            }`,
        },
        {
          title: "Virtual Account",
          description: `${loan?.virtual_accounts[0]?.account_number || "-"} (${loan?.virtual_accounts[0]?.bank_name || "-"
            })`,
        }
      );
      education_details.push(
        {
          title: "Level of Education",
          description: `${loan?.borrower_profile?.educational_attainment || "-"
            }`,
        },
        {
          title: "Employment Status",
          description: `${loan?.borrower_profile?.employment_status || "-"}`,
        },
        {
          title: "Employment Date",
          description: `${loan?.borrower_profile?.work_start_date || "-"}`,
        },
        {
          title: "Sector of Employment",
          description: `${loan?.borrower_profile?.sector_of_employment || "-"}`,
        },
        {
          title: "Current Employer",
          description: `${loan?.borrower_profile?.current_employer || "-"}`,
        },
        {
          title: "Monthly Income",
          description: `${loan?.borrower_profile?.monthly_net_income || "-"}`,
        }
      );
      guarantor.push(
        {
          title: "Guarantor's Name",
          description: `${loan?.guarantor?.first_name ?? "-"}
            ${" "}
            ${loan?.guarantor?.last_name ?? "-"}`,
        },
        {
          title: "Guarantor's Email",
          description: `${loan?.guarantor?.email ?? "-"}`,
        },
        {
          title: "Guarantor's Phone Number",
          description: `${loan?.guarantor?.phone_number ?? "-"}`,
        }
      );
      let schedules = loan?.schedules || [];
      let total_principal = 0;
      let total_interest = 0;
      let total_amount_due = 0;
      let total_amount_paid = 0;
      let total_pending_due = 0;
      let total_penalty = 0;
      const pdf_schedules = [];

      schedules = schedules.map((schedule) => {
        schedule.Principal = `₦${Number(schedule.principal || 0).toLocaleString(
          undefined,
          { minimumFractionDigits: 2 }
        )}`;
        total_principal += Number(schedule.principal || 0);

        schedule.Interest = `₦${Number(schedule?.interest).toLocaleString()}`;
        total_interest += Number(schedule.interest || 0);

        schedule["Amount Due"] = `₦${Number(
          schedule?.principal + schedule?.interest
        ).toLocaleString()}`;
        total_amount_due += Number(
          schedule?.principal + schedule?.interest || 0
        );

        schedule["Amount Paid"] = `₦${Number(schedule?.paid).toLocaleString()}`;
        total_amount_paid += Number(schedule.paid || 0);

        total_pending_due += Number(schedule?.amount_due || 0);
        schedule["Pending Due"] = `₦${Number(
          total_pending_due
        ).toLocaleString()}`;

        schedule.Status = `${schedule?.status}`;
        schedule.Date = `${moment(schedule.due_date).format("MMM DD, YYYY")}`;
        // schedule['Transactions'] = schedule?.loan_transactions;
        // delete schedule.loan_transactions;
        let penalty = 0;
        schedule.loan_transactions.map((tran) => {
          console.log(tran);
          tran.Paid = `₦${Number(tran?.amount).toLocaleString()}`;

          tran.Date = `${moment(tran.created_on).format("MMM DD, YYYY")}`;
          if (tran.entry_type_id == 1) {
            penalty += Number(tran.amount);
          }
          tran.Description = "Payment Received";
          if (tran.status == "success" && tran.entry_type_id !== 1)
            pdf_schedules.push(tran);
          return tran;
        });
        schedule.Penalty = `₦${Number(penalty).toLocaleString()}`;
        total_penalty += Number(penalty || 0);
        schedule.Description = "Repayment";
        delete schedule.principal;
        delete schedule.interest;
        delete schedule.amount_due;
        delete schedule.paid;
        delete schedule.status;
        delete schedule.due_date;
        delete schedule.penalty;
        pdf_schedules.push(schedule);
        return schedule;
      });
      const total = {
        Principal: `₦${total_principal.toLocaleString(undefined, {
          minimumFractionDigits: 2,
        })}`,
        Interest: `₦${total_interest.toLocaleString()}`,
        "Amount Due": `₦${total_amount_due.toLocaleString(undefined, {
          minimumFractionDigits: 2,
        })}`,
        "Amount Paid": `₦${total_amount_paid.toLocaleString(undefined, {
          minimumFractionDigits: 2,
        })}`,
        Penalty: `₦${total_penalty.toLocaleString(undefined, {
          minimumFractionDigits: 2,
        })}`,
      };
      total.Paid = total["Amount Paid"];
      pdf_schedules.push(total);
      schedules.push(total);

      this.setState({
        pdf_schedules,
        loan,
        details,
        loan_history,
        personal_details,
        education_details,
        guarantor,
        schedules,
      });
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        error.response?.statusText ||
        error.message ||
        "Seems like something went wrong with your request. Please try again."
      );
    }
  };

  exportToExcel = (data, fileName) => {
    const fileExtension = ".xlsx";
    FileSaver.saveAs(data, fileName + fileExtension);
    window.location.reload(false);
  };

  exportToPDF = (data, fileName) => {
    const fileExtension = ".pdf";
    FileSaver.saveAs(data, fileName + fileExtension);
    window.location.reload(false);
  };

  render() {
    const {
      // eslint-disable-next-line no-unused-vars
      user,
      history,
    } = this.props;
    const {
      loan,
      schedule,
      schedules = [],
      details = [],
      loan_history = [],
      personal_details = [],
      education_details = [],
      guarantor = [],
      action,
      edit,
      cancel,
      schedule_excel,
      schedule_pdf,
    } = this.state;
    const excelFileName = `${loan?.user?.first_name}_${loan?.user?.last_name}_Loan_Schedule`;
    return (
      <>
        <SideNav page="loans" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="loans" />
            <section className="body-main__content">
              <div className="loans">
                <div className="pageTitle d-lg-none">
                  <h3 className="pageTitle__header">Loan Details</h3>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="">
                      {loan?.status?.status &&
                        !["CANCELLED", "RUNNING", "PAST DUE"].includes(
                          loan?.status?.status
                        ) && (
                          <div className="filter-and-search d-flex justify-content-end">

                            {(loan?.status?.status === "GUARANTOR VALIDATED" ||
                              loan?.status?.status ===
                              "PENDING LENDER'S APPROVAL") &&
                              user.type !== "initiator" && (
                                <>
                                  <div className="button-box me-lg-3">
                                    <Link
                                      type="submit"
                                      onClick={() =>
                                        this.setState({ action: "accept" })
                                      }
                                      className="btn btn-outline-primary"
                                    >
                                      Accept Loan
                                    </Link>
                                  </div>

                                  <div className="button-box me-lg-3">
                                    <Link
                                      type="submit"
                                      onClick={() =>
                                        this.setState({ action: "assign" })
                                      }
                                      className="btn btn-outline-primary"
                                    >
                                      Assign Loan
                                    </Link>
                                  </div>
                                </>
                              )}
                            {loan?.status?.status ===
                              "PENDING BORROWER'S APPROVAL" &&
                              user.id === loan?.created_by && (
                                <div className="button-box me-lg-3">
                                  <Link
                                    type="submit"
                                    onClick={() =>
                                      this.setState({ edit: loan })
                                    }
                                    className="btn btn-outline-primary"
                                  >
                                    Edit Loan
                                  </Link>
                                </div>
                              )}
                            {loan?.status?.status &&
                              user.id == loan?.created_by &&
                              !["CANCELLED", "RUNNING", "SETTLED"].includes(
                                loan?.status?.status
                              ) && (
                                <div className="button-box">
                                  <Link
                                    className="btn btn-danger"
                                    onClick={() =>
                                      this.setState({ cancel: loan })
                                    }
                                  >
                                    Cancel Loan
                                  </Link>
                                </div>
                              )}
                            {(loan?.status?.status === "RUNNING" ||
                              loan?.status?.status === "SETTLED") && (
                                <div className="button-box me-lg-3">
                                  <Link
                                    to={`/createsingleloan?email=${loan?.user?.email}&phone_number=${loan?.user?.phone_number}&interest_rate=${loan?.interest_rate}&loan_amount=${loan?.loan_amount}`}
                                    className="btn btn-outline-primary"
                                  >
                                    Initiate New Loan
                                  </Link>
                                </div>
                              )}
                          </div>
                        )}
                      {loan?.status?.status &&
                        ["CANCELLED", "RUNNING", "PAST DUE"].includes(
                          loan?.status?.status
                        ) && (
                          <div className="filter-and-search d-flex justify-content-end">
                            <div className="button-box me-lg-3">
                              <Link to="/loans" className="btn btn-danger">
                                Close
                              </Link>
                            </div>
                          </div>
                        )}

                      <div className="card default-card page-table mb-4">
                        <div className="row">
                          <div className="col-12 col-md-12" key="Avatar">
                            <h6 className="fw-bold">Avatar</h6>
                            <h6 className="fw-bold">
                              <span>
                                <a
                                  href={loan?.user?.photo_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    src={loan?.user?.photo_url}
                                    height="200"
                                    width="200"
                                  />
                                </a>
                              </span>
                            </h6>
                          </div>
                        </div>
                      </div>
                      {!!personal_details.length && (
                        <div className="card default-card page-table mb-4">
                          <div className="row">
                            {personal_details.map((detail) => (
                              <div
                                className="col-12 col-md-3"
                                key={detail.title}
                              >
                                <h6 className="fw-bold">{detail.title}</h6>
                                <p className="mb-8">
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: detail.description,
                                    }}
                                  ></span>
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {!!details.length && (
                        <div className="card default-card page-table mb-4">
                          <div className="row">
                            {details.map((detail) => (
                              <div
                                className="col-12 col-md-3"
                                key={detail.title}
                              >
                                <div>
                                  <h6 className="fw-bold">{detail.title}</h6>
                                  <p className="mb-8">{detail.description}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {!!loan_history.length && (
                        <div className="card default-card page-table mb-4">
                          <div className="row">
                            {loan_history.map((detail) => (
                              <div
                                className="col-12 col-md-3"
                                key={detail.title}
                              >
                                <div>
                                  <h6 className="fw-bold">{detail.title}</h6>
                                  <p className="mb-8">{detail.description}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {!!education_details.length && (
                        <div className="card default-card page-table mb-4">
                          <div className="row">
                            {education_details.map((detail) => (
                              <div
                                className="col-12 col-md-3"
                                key={detail.title}
                              >
                                <div>
                                  <h6 className="fw-bold">{detail.title}</h6>
                                  <p className="mb-8">{detail.description}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {!!guarantor.length && (
                        <div className="card default-card page-table mb-4">
                          <div className="row">
                            {guarantor.map((detail) => (
                              <div
                                className="col-12 col-md-3"
                                key={detail.title}
                              >
                                <div>
                                  <h6 className="fw-bold">{detail.title}</h6>
                                  <p className="mb-8">{detail.description}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      <div className="filter-and-search">
                        <div className="filter-box d-flex">
                          <div className="search-box"></div>
                        </div>

                        {schedule_pdf && schedule_excel && (
                          <div className="button-box dropdown">
                            <button
                              type="submit"
                              className="btn btn-primary dropbtn"
                            >
                              Export
                            </button>
                            <div className="dropdown-content">
                              <a
                                href={schedule_pdf}
                                target="_blank"
                                rel="noreferrer"
                              >
                                View
                              </a>
                              <a
                                href="javascript:void(0)"
                                onClick={(e) =>
                                  this.exportToPDF(schedule_pdf, excelFileName)
                                }
                              >
                                PDF
                              </a>
                              <a
                                href="javascript:void(0)"
                                onClick={(e) =>
                                  this.exportToExcel(
                                    schedule_excel,
                                    excelFileName
                                  )
                                }
                              >
                                Excel
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="row">
                        <div className="col" id="exportSchedule">
                          <div className="card default-card settings">
                            <Nav className="nav nav-tabs" as="ul">
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link
                                  className="nav-link active"
                                  eventKey="profile"
                                >
                                  Loan Repayment Schedule
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                            {schedules && (
                              <div className="tab-content">
                                <div className="tab-pane fade show active">
                                  <div className="table-responsive">
                                    <table
                                      className="table"
                                      style={{ textAlign: "center" }}
                                    >
                                      <thead className="bg-secondary">
                                        <tr>
                                          <th className="sn text-white">S/N</th>
                                          <th className="date-time text-white">
                                            Due Date
                                          </th>
                                          <th className="loan_amount text-white">
                                            Principal
                                          </th>
                                          <th className="interest text-white">
                                            Interest
                                          </th>
                                          <th className="amount_due text-white">
                                            Amount Due
                                          </th>
                                          <th className="amount_paid text-white">
                                            Amount Paid
                                          </th>
                                          <th className="pending_due text-white">
                                            Loan Balance
                                          </th>
                                          <th className="status text-white">
                                            Status
                                          </th>
                                          <th className="action text-white">
                                            Action
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {schedules.map((schedule, index) => (
                                          <tr key={schedule.id}>
                                            {index + 1 === schedules.length && (
                                              <td className="sn">
                                                <span className="sn">
                                                  Total
                                                </span>
                                              </td>
                                            )}
                                            {index + 1 !== schedules.length && (
                                              <td className="sn">
                                                <span className="sn">
                                                  {index + 1 ?? "---"}
                                                </span>
                                              </td>
                                            )}
                                            <td className="date-time">
                                              <span className="date">
                                                {schedule.Date ?? "---"}
                                              </span>
                                            </td>
                                            <td className="loan_amount">
                                              {schedule.Principal}
                                            </td>
                                            <td className="interest">
                                              {schedule.Interest}
                                            </td>
                                            <td className="amount_due">
                                              {schedule["Amount Due"]}
                                            </td>

                                            <td className="amount_paid">
                                              {schedule["Amount Paid"]}
                                            </td>
                                            <td className="pending_due">
                                              {schedule["Pending Due"] ?? "---"}
                                            </td>
                                            <td className="status">
                                              {schedule.Status ?? "---"}
                                            </td>
                                            <td className="action">
                                              {schedule.Date &&
                                                schedule.Status && (
                                                  <span
                                                    style={{
                                                      color: "green",
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      this.setState({
                                                        schedule,
                                                      })
                                                    }
                                                  >
                                                    View Transactions
                                                  </span>
                                                )}
                                              {(!schedule.Date ||
                                                !schedule.Status) && (
                                                  <span>---</span>
                                                )}
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
        <LoanScheduleTransactions
          visible={!!schedule}
          data={schedule}
          onClose={() => this.setState({ schedule: null })}
        />

        <EditLoan
          visible={!!edit}
          data={edit}
          onSubmit={() => this.fetchLoanDetails(loan.id)}
          onClose={() => this.setState({ edit: null })}
        />

        <AssignLoan
          visible={action === "assign"}
          data={loan}
          onSubmit={() => this.fetchLoanDetails(loan.id)}
          onClose={() => this.setState({ action: null })}
        />

        <CancelLoan
          visible={cancel}
          data={cancel}
          onSubmit={() => this.fetchLoanDetails(loan.id)}
          onClose={() => this.setState({ cancel: null })}
        />
        <AcceptLoan
          visible={action === "accept"}
          data={[loan]}
          onSubmit={() => this.fetchLoanDetails(loan.id)}
          onClose={() => this.setState({ action: null })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  business: state.account?.business || {},
  user: state.account?.user || {},
});

const mapDispatchToProps = { fillUser };

export default connect(mapStateToProps, mapDispatchToProps)(ViewLoan);
